import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/** Preserve attribution through automatic redirects; expose pageview readiness. */
export function usePageRedirect(destination: string | null, pending = false) {
  const navigate = useNavigate();
  const { search, hash } = useLocation();

  useEffect(() => {
    if (destination && !pending) {
      navigate({ pathname: destination, search, hash }, { replace: true });
    }
  }, [destination, pending, navigate, search, hash]);

  return !pending && !destination;
}
